const CookieDisclaimer = {
  data () {
    return {
      isActive: true
    }
  },
  props: [
    'cookieName',
    'daysToExpiration'
  ],
  computed: {
    cookieExists: function () {
      return this.getCookie(this.cookieName)
    }
  },
  methods: {
    getCookie: (cookieName) => {
      const cookie = "; " + document.cookie
      const parts = cookie.split("; " + cookieName + "=")
      if (parts.length ==  2) {
        return parts.pop().split(";").shift()
      }
    },
    setCookie: function() {
      const daysToExpiration = parseInt(this.daysToExpiration)

      let expirationDate = new Date()
      expirationDate.setTime(expirationDate.getTime() + (daysToExpiration*24*60*60*1000))
      expirationDate = expirationDate.toUTCString()

      this.isActive = false

      document.cookie = `${this.cookieName}=true; expires=${expirationDate}; path=/`
    }
  }
}

export default CookieDisclaimer
